<template>
  <div class="body">
    <el-row style="text-align: left; margin: 1% auto;">
      <!--      <el-button class="body-btn" type="danger">关闭</el-button>-->
      <el-button class="body-btn" :loading="printSalesOrderLoading" type="success" @click="printSalesOrderVO">打印</el-button>
      <!--      <el-button class="body-btn" type="success">财务打印</el-button>-->
      <!--      <el-button class="body-btn" type="success">部件产品打印</el-button>-->
      <!--      <el-button class="body-btn" type="primary">生产流水单预览</el-button>-->
      <!--      <el-button class="body-btn" type="primary">控制柜流水单</el-button>-->
      <!--      <el-button class="body-btn" type="primary">LOP流水单</el-button>-->
      <!--      <el-button class="body-btn" type="primary">COP流水单</el-button>-->
      <!--      <el-button class="body-btn" type="primary">奥的斯控制柜流水单</el-button>-->
      <!--      <el-button class="body-btn" type="primary">蒂森控制柜流水单</el-button>-->
      <!--      <el-button class="body-btn" type="primary">蒂森控制柜流水单V2</el-button>-->
      <!--      <el-button class="body-btn" type="primary">芯片功能程序项目信息表</el-button>-->
    </el-row>
    <el-tabs type="border-card">
      <el-tab-pane label="主表信息">
        <table class="gridtable">
          <tr>
            <td class="tableLabel">出厂编号</td>
            <td style="width: 23%">{{salesOrder.factoryNO}}</td>
            <td class="tableLabel">制单人</td>
            <td style="width: 23%">{{salesOrder.creatorName}}</td>
            <td class="tableLabel">制单时间</td>
            <td>{{salesOrder.createDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">合同编号</td>
            <td>{{salesOrder.clientContractNO}}</td>
            <td class="tableLabel">订单类型</td>
            <td>{{salesOrder.orderType}}</td>
            <td class="tableLabel">提交时间</td>
            <td>{{salesOrder.submitTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">项目名称</td>
            <td>{{salesOrder.projectName}}</td>
            <td class="tableLabel">SAP订单号</td>
            <td>--</td>
            <td class="tableLabel">项目类型</td>
            <td>{{salesOrder.salesOrderNO}}</td>
          </tr>
          <tr>
            <td class="tableLabel">客户名称</td>
            <td>{{salesOrder.invoiceName}}</td>
            <td class="tableLabel">联系人</td>
            <td>{{salesOrder.contact}}</td>
            <td class="tableLabel">电话</td>
            <td>{{salesOrder.telephone}}</td>
          </tr>
          <tr>
            <td class="tableLabel">要求交期</td>
            <td>收到预付款后{{salesOrder.deliveryDate}}个工作日</td>
            <td class="tableLabel">安装地点</td>
            <td>--</td>
            <td class="tableLabel">订单种类</td>
            <td>--</td>
          </tr>
          <tr>
            <td class="tableLabel">最终交期</td>
            <td>--</td>
            <td class="tableLabel">SAP订单类型</td>
            <td>--</td>
            <td class="tableLabel">SAP客户类型</td>
            <td>--</td>
          </tr>
          <tr>
            <td class="tableLabel">送货地点</td>
            <td colspan="3">{{salesOrder.deliveryPlace}}</td>
            <td class="tableLabel">含控制柜</td>
            <td>--</td>
          </tr>
          <tr>
            <td class="tableLabel">付款方式</td>
            <td>{{salesOrder.paymentMethod}}</td>
            <td class="tableLabel">电气</td>
            <td>--</td>
            <td class="tableLabel">部件</td>
            <td>--</td>
          </tr>
          <tr>
            <td class="tableLabel">运输类型</td>
            <td>{{salesOrder.transportType}}</td>
            <td class="tableLabel">其他运输</td>
            <td colspan="3">{{salesOrder.otherTransport}}</td>
          </tr>
          <tr>
            <td class="tableLabel">包装箱选择</td>
            <td>{{salesOrder.shippingMark}}</td>
            <td class="tableLabel">特殊包装要求</td>
            <td colspan="3">--</td>
          </tr>
          <tr>
            <td class="tableLabel">包装备注</td>
            <td colspan="5">{{salesOrder.packingNote}}</td>
          </tr>
          <tr>
            <td class="tableLabel">关键物料</td>
            <td colspan="5" style="padding: 4px;">
              <el-input size="mini" style="width: 300px; margin-right: 10px;"/>
              <el-button size="mini" type="primary">选择</el-button>
              <el-button size="mini" type="primary">删除</el-button>
              <el-button size="mini" type="primary">保存</el-button>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">备注</td>
            <td colspan="5">{{salesOrder.note}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="费用清单">
        <table class="gridtable" style="width: 100%; margin-top: 10px;">
          <tr>
            <th>其他产品</th>
            <th>规格型号</th>
            <th>单位</th>
            <th>数量</th>
            <th>单价</th>
            <th>金额</th>
            <th>备注</th>
            <th>审批意见</th>
          </tr>
        </table>
        <table class="gridtable" style="width: 100%; margin-top: 10px;">
          <tr>
            <th>费用名称</th>
            <th>费用</th>
            <th>备注</th>
          </tr>
          <tr v-for="(item, i) in salesOrder.salesOrderExpenseVOes" :key="i">
            <td>{{item.expenseName}}</td>
            <td>{{item.expense}}</td>
            <td>{{item.note}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="SAP销售订单明细">
        SAP销售订单明细
      </el-tab-pane>
      <el-tab-pane label="发票信息">
        <table class="gridtable" style="width: 100%;" cellspacing="0">
          <tr>
            <td class="tableLabel">发票类型</td>
            <td style="width: 23%">{{salesOrder.invoiceType}}</td>
            <td colspan="2" rowspan="1" style="padding: 0">
              <table style="border-collapse: collapse; width: 100%">
                <tr>
                  <td style="width: 30%; text-align: right; background-color: #D1E6F5;">包含明细</td>
                  <td style="width: 20%;">{{salesOrder.isIncludeDetail}}</td>
                  <td style="width: 30%; text-align: right; background-color: #D1E6F5;">是否开软件</td>
                  <td style="width: 20%;">{{salesOrder.invoiceIncludeSoftware}}</td>
                </tr>
              </table>
            </td>
            <td class="tableLabel">联络处</td>
            <td>{{salesOrder.liaisonOffice}}</td>
          </tr>
          <tr>
            <td class="tableLabel">发票抬头</td>
            <td style="width: 23%">{{salesOrder.invoiceName}}</td>
            <td class="tableLabel">税号</td>
            <td style="width: 23%">{{salesOrder.invoiceVATNO}}</td>
            <td class="tableLabel">开票银行</td>
            <td>{{salesOrder.invoiceBank}}</td>
          </tr>
          <tr>
            <td class="tableLabel">账号</td>
            <td>{{salesOrder.invoiceAccounts}}</td>
            <td class="tableLabel">电话</td>
            <td>{{salesOrder.invoiceTelephone}}</td>
            <td class="tableLabel">发票地址</td>
            <td>{{salesOrder.invoiceAddress}}</td>
          </tr>
          <tr>
            <td class="tableLabel">发票备注</td>
            <td colspan="5">{{salesOrder.invoiceNote}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="附件">
<!--        <el-button type="primary">下载所有附件</el-button>-->
        <el-table :data="salesOrder.salesOrderAttachmentVOes" style="width: 100%; margin-top: 20px">
          <el-table-column prop="fileName" label="名称" align="center"/>
          <el-table-column prop="typeName" label="类型" align="center"/>
          <el-table-column label="下载" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
              <!--              <el-button type="danger" @click="attachmentDelete(scope.row)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="跟踪信息">
        跟踪信息
      </el-tab-pane>
    </el-tabs>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";

  export default {
    name: "SalesOrderPreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        salesOrder: {},
        printSalesOrderLoading: false,
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `sd/so/${this.billId}/0`)
          .then(resp => {
            this.$emit("loading-status", {"loading": false});
            // console.log(resp);
            this.salesOrder = resp.data;
          });
      },
      downLoad(row) {
        let str = row.filePath.slice(0, 1);
        if (str === "~") {
          let url = window.config.fileServerUrl + row.filePath.replace("~", "");
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        } else {
          let data = {
            name: row.fileName,
            uuid: row.filePath,
          };
          this.$http
            .exportFile("basic", "file/download", data)
            .then((res) => {
              let blob = new Blob([res.data], { type: "application" });
              let fileName = decodeURI(res.config.params.name);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              // this.downLoadLoading = false;
            })
            .catch(() => {
              // this.downLoadLoading = false;
              this.$message.error("下载失败");
            });
        }
      },
      printSalesOrderVO() {
        this.printSalesOrderLoading = true;
        let parms={
          techParamBillId:this.billId,
        };
        this.$http
          .exportFile("basic", "sd/so/print",parms)
          .then((res) => {
            let blob = new Blob([res.data], {type: "application/pdf"});
            console.log(res);
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            // a.download = "可配置电子订单系统";
            a.target="_blank";
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
            // let pdfUrl = window.URL.createObjectURL(blob);
            // window.open(pdfUrl,"可配置电子订单系统");
            this.printSalesOrderLoading = false;
          });
      },
      submit() {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "", this.department)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
    },
  };
</script>
<style lang="scss">
  .body {
    .el-button + .el-button{
      margin-left: 0;
    }
    .el-tabs--border-card > .el-tabs__content{
      padding: 10px;
    }
    .body-btn{
      margin-bottom: 2px;
      margin-right: 2px;
    }
    table.gridtable {
      font-family: verdana,arial,sans-serif;
      font-size:11px;
      color:#333333;
      border-width: 1px;
      border-color: #dddddd;
      border-collapse: collapse;
      width: 100%;
    }
    table.gridtable th {
      text-align: left;
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #dddddd;
      background-color: #D1E6F5;
    }
    table.gridtable td {
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #dddddd;
    }
    .tableLabel {
      width: 10%;
      text-align: right;
      background-color: #D1E6F5;
    }
  }
</style>
